import { Component, input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest, map, Observable } from 'rxjs';

export interface LandingPageDataType {
	serviceName: string;
	description: string;
	explanation: string;
	pricing: string;
	//documents: string;
	image: {
		url: string;
		title?: string;
	};
	howItWorks?: string;
}

@Component({
	selector: 'landing-page',
	templateUrl: './landing-page.component.html',
	styleUrls: ['./landing-page.component.scss'],
	standalone: false,
})
export class LandingPageComponent implements OnInit {
	public readonly data = input<LandingPageDataType>();

	public translations$!: Observable<{
		howItWorks: string;
		pricingAndDocuments: string;
	}>;

	constructor(private translate: TranslateService) {}

	public ngOnInit(): void {
		this.translations$ = combineLatest([
			this.translate.stream('landingPage.howItWorks'),
			this.translate.stream('landingPage.pricingAndDocuments'),
		]).pipe(
			map(([howItWorks, pricingAndDocuments]) => ({
				howItWorks,
				pricingAndDocuments,
			}))
		);
	}
}
